import { Component, inject } from '@angular/core';
import { BackendApi } from '../../services/backend-api';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AgGridAngular } from "ag-grid-angular";
import type { AutoSizeStrategy, ColDef, GridReadyEvent } from "ag-grid-community";
import { Country } from '../../models/country';
import { AG_GRID_LOCALE_FR } from '@ag-grid-community/locale';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-list-countries',
  imports: [AgGridAngular, MatIconModule],
  templateUrl: './list-countries.html',
  styleUrl: './list-countries.css',
})
export class ListCountries {
  constructor(
    private readonly backendApi: BackendApi
  ) { }

  private _snackBar = inject(MatSnackBar);

  public autoSizeStrategy: AutoSizeStrategy = {
    type: 'fitGridWidth',
    defaultMinWidth: 100,
  };

  public columns: ColDef<Country>[] = [
    { field: "flag", headerName: "", filter: false, sortable: false, width: 100 },
    { field: "code", headerName: "Code alpha-3", filter: true, floatingFilter: true, width: 100 },
    { field: "name", headerName: "Nom international", filter: true, floatingFilter: true },
    { field: "name_fr", headerName: "Nom français", filter: true, floatingFilter: true }
  ];

  public localeText = AG_GRID_LOCALE_FR;

  onGridReady(event: GridReadyEvent) {
    this.backendApi.getCountries().subscribe({
      next: (countries) => {
        event.api.setGridOption('rowData', countries);
        event.api.setGridOption('loading', false);
      },
      error: () => {
        // Error encountered
        event.api.setGridOption('loading', false);
        this._snackBar.open("Erreur rencontrée lors de la recuperation des pays.");
      }
    })
  }
}
